import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/UserUpdateSkillButoon';
// FOR ONE GRAPHQL QUERY
export const UPDATE_USER_SKILL = defineAsyncActionTypes(`${prefix}/UPDATE_USER_SKILL`);
